import React from "react";
import { observer } from "mobx-react";
import { Modal } from "@lib/modal";
import { useTranslation } from "react-i18next";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";

export default observer(function RefreshPagePopup(props: {
	shouldShowPageRefreshPopup: boolean;
}) {
	const { t } = useTranslation("login");

	if (!props.shouldShowPageRefreshPopup) {
		return null;
	}

	return (
		<Modal>
			<div id="reuse-form" className="popup">
				<div className="popup__card popup__card--med">
					<div className="popup__header">
						<p>{t("ERR_HANDLING.USER_UNABLE")}</p>
					</div>
					<div className="popup__body">
						<InfoMessageComponent
							type="warning"
							message={t<string>(
								"ERR_HANDLING.PROCESSING_REQUEST"
							)}
						/>
						<button
							className="btn btn--wrap btn--wrap--base btn--block btn--primary--inverted btn--icon u-mar--top--sml"
							onClick={() => window.location.reload()}
						>
							{t("COMMON.RELOAD")}
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
});
